import React, { FC } from "react";
import { RadioButtonWithLabel } from "../../../../components";
import { Heading } from "@telia/teddy";
import { PaymentMethod } from "../../../../../../constants";
import TEXT from "../../../text-consts";
import { getPaymentMethodImages } from "../../../utils";
import AnnouncementText from "../../atoms/AnnouncementText/AnnouncementText";
import "./PaymentMethods.less";

interface ImagesProps {
    images: {
        alt: string;
        url: string;
    }[];
    method: PaymentMethod;
}

interface PaymentMethodsProps {
    isDisabled?: boolean;
    methods: PaymentMethod[];
    onChange: (value: PaymentMethod) => void;
    selectedType?: PaymentMethod;
}

const Images: FC<ImagesProps> = ({ images, method }) => (
    <div className="payment-methods__images">
        {images.map(({ url, alt }) => (
            <img
                className="payment-methods__image"
                key={`payment-methods-${method}-image-${alt}`}
                src={url}
                alt={alt}
            />
        ))}
    </div>
);

const PaymentMethods: FC<PaymentMethodsProps> = ({ isDisabled, methods, selectedType, onChange }) => (
    <div className="payment-methods">
        <AnnouncementText typeId="co_payment_options" />
        {methods.map((method) => {
            const images = getPaymentMethodImages(method);

            return (
                <div key={`payment-option-${method}`} className="payment-methods__option">
                    <RadioButtonWithLabel
                        value={method}
                        onChange={(event) => onChange(event.target.value as PaymentMethod)}
                        name={`payment-methods`}
                        checked={selectedType === method}
                        hasRichContent
                        disabled={isDisabled}
                    >
                        <Heading mb="100" as="h3" variant="title-100" className="payment-methods__heading">
                            {TEXT.PAYMENT.DESCRIPTION_FOR(method)}
                        </Heading>
                        {images.length > 0 && <Images images={images} method={method} />}
                    </RadioButtonWithLabel>
                </div>
            );
        })}
    </div>
);

export default PaymentMethods;
